import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_390: DocMigration = {
  maxSchemaVersion: "0.0.390",
  description: "Add viewTemplateOverrideIds to viewports",
  apply(json: any) {
    for (const viewportId in json.viewports) {
      json.viewports[viewportId].viewTemplateOverrideIds = [];
    }
    return json;
  },
};

export default migration_0_0_390;
